module.exports = __webpack_public_path__ + "static/media/welcome_page_full.d980e81e.png";